import React from 'react';

export default function ReadOnlyLabel({ children }) {
    return (
        <label className={'kt-font-bold text-primary'} style={{ marginTop: '9px' }}>
            {children}
        </label>
    );
}
